var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 5.51758V0.517578H15.5V5.51758H8.83333ZM0.5 8.85091V0.517578H7.16667V8.85091H0.5ZM8.83333 15.5176V7.18425H15.5V15.5176H8.83333ZM0.5 15.5176V10.5176H7.16667V15.5176H0.5ZM2.16667 7.18425H5.5V2.18424H2.16667V7.18425ZM10.5 13.8509H13.8333V8.85091H10.5V13.8509ZM10.5 3.85091H13.8333V2.18424H10.5V3.85091ZM2.16667 13.8509H5.5V12.1842H2.16667V13.8509Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.5c39feba6f4a05fcefbc1806702d8daa.svg";
export { ForwardRef as ReactComponent };